import React from 'react';
import classNames from 'classnames';
import useMedian from '../../../hooks/useMedian';
import css from './PopupOpenerButton.module.css';

/**
 * PopupOpenerButton component
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.isSelected] - Whether the filter is selected
 * @param {number} [props.labelMaxWidth] - The maximum width of the label
 * @param {Function} props.toggleOpen - The function to toggle the filter
 * @param {React.Node} props.children - The children
 * @returns {JSX.Element}
 */
const PopupOpenerButton = props => {
  const { isMedian } = useMedian();
  const { isSelected = false, labelMaxWidth = null, toggleOpen, children, ...rest } = props;

  const labelStyles = classNames(
    isSelected ? css.labelSelected : css.label,
    isMedian && (isSelected ? css.labelSelectedMedian : css.labelMedian)
  );
  const labelMaxWidthMaybe = labelMaxWidth ? { maxWidth: `${labelMaxWidth}px` } : {};
  const labelMaxWidthStyles = labelMaxWidth ? css.labelEllipsis : null;

  return (
    <button
      className={classNames(labelStyles, labelMaxWidthStyles)}
      style={labelMaxWidthMaybe}
      onClick={() => toggleOpen()}
      {...rest}
    >
      {children}
    </button>
  );
};

export default PopupOpenerButton;
